import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState, useEffect } from "react";
import DataTable from "react-data-table-component";
import { CircularProgress } from "@mui/material";
import { BorderBottom, BorderRight } from "@mui/icons-material";
import Datatablenoresults from "layouts/Datatablenoresults";
// Custom Styles
export var customStyles = {
    rows: {
        style: {
            minHeight: "52px"
        }
    },
    headCells: {
        style: {
            paddingLeft: "15px",
            paddingRight: "15px",
            color: "rgba(76, 78, 100, 0.87)",
            fontFamily: "Sarabun",
            fontSize: "16px",
            background: " #F5F5F7",
            paddingTop: "15px",
            paddingBottom: "15px",
            BorderRight: 1
        }
    },
    cells: {
        style: {
            paddingLeft: "15px",
            paddingRight: "15px",
            paddingTop: "10px",
            paddingBottom: "10px",
            color: "rgba(76, 78, 100, 0.87)",
            fontFamily: "Sarabun",
            fontSize: "16px",
            fontWeight: "300"
        }
    }
};
// Custom Pagination Component
var CustomPagination = function(param) {
    var currentPage = param.currentPage, currentPageSize = param.currentPageSize, totalPage = param.totalPage, totalAmount = param.totalAmount, onChangePage = param.onChangePage, onChangePageSize = param.onChangePageSize, pageSizeOptions = param.pageSizeOptions;
    // คำนวณ range ของข้อมูลที่แสดง
    var startItem = (currentPage - 1) * currentPageSize + 1;
    var endItem = Math.min(currentPage * currentPageSize, totalAmount);
    var maxPage = Math.ceil(totalAmount / currentPageSize);
    // const startRow = rowCount === 0 ? 0 : (currentPage - 1) * rowsPerPage + 1;
    // const endRow = Math.min(currentPage * rowsPerPage, rowCount);
    var handleFirst = function() {
        onChangePage(1);
    };
    var handleLast = function() {
        onChangePage(maxPage);
    };
    return /*#__PURE__*/ _jsxs("div", {
        style: {
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "center",
            padding: "15px 10px",
            gap: "15px",
            fontSize: "14px",
            color: "#333",
            borderTop: "1px solid #e0e0e0"
        },
        children: [
            /*#__PURE__*/ _jsxs("div", {
                style: {
                    display: "flex",
                    alignItems: "center",
                    gap: "8px"
                },
                children: [
                    /*#__PURE__*/ _jsx("span", {
                        style: {
                            fontSize: "14px",
                            color: "#666"
                        },
                        children: "จำนวนรายการต่อหน้า"
                    }),
                    /*#__PURE__*/ _jsx("select", {
                        value: currentPageSize,
                        onChange: function(e) {
                            return onChangePageSize(Number(e.target.value));
                        },
                        style: {
                            padding: "4px 8px",
                            border: "1px solid #ddd",
                            borderRadius: "4px",
                            fontSize: "14px",
                            cursor: "pointer",
                            outline: "none"
                        },
                        children: pageSizeOptions.map(function(size) {
                            return /*#__PURE__*/ _jsx("option", {
                                value: size,
                                children: size
                            }, size);
                        })
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("div", {
                children: /*#__PURE__*/ _jsxs("span", {
                    children: [
                        startItem,
                        "-",
                        endItem,
                        " of ",
                        totalAmount
                    ]
                })
            }),
            /*#__PURE__*/ _jsxs("div", {
                style: {
                    display: "flex",
                    gap: "5px"
                },
                children: [
                    /*#__PURE__*/ _jsx("button", {
                        onClick: handleFirst,
                        disabled: currentPage === 1,
                        style: {
                            padding: "6px 10px",
                            border: "none",
                            backgroundColor: "transparent",
                            cursor: currentPage === 1 ? "not-allowed" : "pointer",
                            color: currentPage === 1 ? "#ccc" : "#666",
                            fontSize: "18px"
                        },
                        title: "หน้าแรก",
                        children: "⟪"
                    }),
                    /*#__PURE__*/ _jsx("button", {
                        onClick: function() {
                            return onChangePage(currentPage - 1);
                        },
                        disabled: currentPage === 1,
                        style: {
                            padding: "6px 10px",
                            border: "none",
                            backgroundColor: "transparent",
                            cursor: currentPage === 1 ? "not-allowed" : "pointer",
                            color: currentPage === 1 ? "#ccc" : "#666",
                            fontSize: "18px"
                        },
                        title: "หน้าก่อน",
                        children: "‹"
                    }),
                    /*#__PURE__*/ _jsx("button", {
                        onClick: function() {
                            return onChangePage(currentPage + 1);
                        },
                        disabled: currentPage === totalPage,
                        style: {
                            padding: "6px 10px",
                            border: "none",
                            backgroundColor: currentPage === "transparent",
                            cursor: currentPage === totalPage ? "not-allowed" : "pointer",
                            color: currentPage === totalPage ? "#ccc" : "#333",
                            fontSize: "18px"
                        },
                        title: "หน้าถัดไป",
                        children: "›"
                    }),
                    /*#__PURE__*/ _jsx("button", {
                        onClick: handleLast,
                        disabled: currentPage >= maxPage,
                        style: {
                            padding: "6px 10px",
                            border: "none",
                            backgroundColor: "transparent",
                            cursor: currentPage >= maxPage ? "not-allowed" : "pointer",
                            color: currentPage >= maxPage ? "#ccc" : "#666",
                            fontSize: "18px"
                        },
                        title: "หน้าสุดท้าย",
                        children: "⟫"
                    })
                ]
            })
        ]
    });
};
var SortIconAsc = function() {
    return /*#__PURE__*/ _jsx("span", {
        children: "▲"
    });
};
var SortIconDesc = function() {
    return /*#__PURE__*/ _jsx("span", {
        children: "▼"
    });
};
// Main Component
export default function DatatableLayoutPagination(_param) {
    var loading = _param.loading, columns = _param.columns, item = _param.item, totalPage = _param.totalPage, totalAmount = _param.totalAmount, currentPage = _param.currentPage, currentPageSize = _param.currentPageSize, onChangePage = _param.onChangePage, onChangePageSize = _param.onChangePageSize, handleSort = _param.handleSort, sortModel = _param.sortModel, props = _object_without_properties(_param, [
        "loading",
        "columns",
        "item",
        "totalPage",
        "totalAmount",
        "currentPage",
        "currentPageSize",
        "onChangePage",
        "onChangePageSize",
        "handleSort",
        "sortModel"
    ]);
    return /*#__PURE__*/ _jsx(DataTable, {
        columns: columns,
        data: item,
        progressPending: loading,
        progressComponent: /*#__PURE__*/ _jsx(CircularProgress, {
            style: {
                color: "#b00612"
            }
        }),
        pagination: true,
        paginationComponent: function() {
            return /*#__PURE__*/ _jsx(CustomPagination, {
                currentPage: currentPage,
                currentPageSize: currentPageSize,
                totalPage: totalPage,
                totalAmount: totalAmount,
                onChangePage: onChangePage,
                onChangePageSize: onChangePageSize,
                pageSizeOptions: [
                    5,
                    10,
                    25,
                    50,
                    100
                ],
                showPageSize: true
            });
        },
        paginationServer: true,
        sortServer: true,
        onSort: handleSort,
        defaultSortFieldId: (sortModel === null || sortModel === void 0 ? void 0 : sortModel.sortField) || "",
        defaultSortAsc: (sortModel === null || sortModel === void 0 ? void 0 : sortModel.sortValue) === "asc",
        sortIconAsc: /*#__PURE__*/ _jsx(SortIconAsc, {}),
        sortIconDesc: /*#__PURE__*/ _jsx(SortIconDesc, {}),
        customStyles: customStyles,
        noDataComponent: /*#__PURE__*/ _jsx(Datatablenoresults, {})
    });
}
